module.exports = __webpack_public_path__ + "static/favicon-aa3db180a7816356812929df0910951e.png";